import { toast } from 'sonner'

export const infoToast = (msg: string) => toast.success(msg.toString())
export const errorToast = (msg: any) => toast.error(msg)
// Neutral notice — neither a green "success" nor a red "error". Used for
// expected, non-error events (e.g. session expiry → "please sign in again").
export const neutralToast = (msg: any) => toast(msg)
